
export function SearchIcon3D() {
  return (
    <div className="relative w-11 h-11">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full shadow-lg transform rotate-3"></div>
      <div className="relative flex items-center justify-center w-full h-full">
        <svg 
          className="w-5 h-5 text-white transform -rotate-3" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
          strokeWidth="2"
        >
          <circle cx="11" cy="11" r="8"/>
          <path d="m21 21-4.35-4.35" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-blue-300 rounded-full opacity-60"></div>
    </div>
  );
}

export function ThumbsUpIcon3D() {
  return (
    <div className="relative w-11 h-11">
      <div className="absolute inset-0 bg-gradient-to-br from-green-400 to-green-600 rounded-full shadow-lg transform rotate-6"></div>
      <div className="relative flex items-center justify-center w-full h-full">
        <svg 
          className="w-5 h-5 text-white transform -rotate-6" 
          fill="currentColor" 
          viewBox="0 0 24 24"
        >
          <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/>
        </svg>
      </div>
      <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-green-300 rounded-full opacity-60"></div>
    </div>
  );
}

export function StarIcon3D() {
  return (
    <div className="relative w-11 h-11">
      <div className="absolute inset-0 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full shadow-lg transform -rotate-12"></div>
      <div className="relative flex items-center justify-center w-full h-full">
        <svg 
          className="w-6 h-6 text-white transform rotate-12" 
          fill="currentColor" 
          viewBox="0 0 24 24"
        >
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
      </div>
      <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-yellow-300 rounded-full opacity-60"></div>
    </div>
  );
}

export function UserIcon3D() {
  return (
    <div className="relative w-11 h-11">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-400 to-blue-600 rounded-full shadow-lg transform rotate-3"></div>
      <div className="relative flex items-center justify-center w-full h-full">
        <svg 
          className="w-6 h-6 text-white transform -rotate-3" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
          strokeWidth="2"
        >
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      </div>
      <div className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-blue-300 rounded-full opacity-60"></div>
    </div>
  );
}
